import {
    valueOnlyHasLetters,
    valueOnlyHasNumbers,
    valueOnlyHasNumbersAndLetters,
} from "../../../../../../../components/util/Helpers/Regex";

export const filterValidation = ({ setSnackbarMessage, toggleSnackbar }) => {
    const setMessage = (filterKey = "", wrongType) => {
        setSnackbarMessage(`${filterKey} não pode conter ${wrongType} ou caracteres especiais`);
        toggleSnackbar();
    };

    const setMessageAlfaNumerico = (filterKey = "") => {
        setSnackbarMessage(`${filterKey} não pode conter caracteres especiais`);
        toggleSnackbar();
    };

    const setMessageEmptyKey = (filterKey = "") => {
        setSnackbarMessage(`${filterKey} não pode estar vazio`);
        toggleSnackbar();
    };

    const isFilterTypeValid = (key = "", value) => {
        if (value === "" || value === 0) {
            setMessageEmptyKey(key);
            return false;
        }

        // Somente acessórios
        if (key === "Número da Ficha") {
            return true;
        }

        if (key === "ID do Produto") {
            if (valueOnlyHasNumbers(value)) {
                return true;
            }
            setMessage(key, "letras");
            return false;
        }

        if (key === "Alfa numérico") {
            if (valueOnlyHasNumbersAndLetters(value)) {
                return true;
            }

            setMessageAlfaNumerico(key);
            return false;
        }

        if (valueOnlyHasLetters(value)) {
            return true;
        }

        setMessage(key, "números");
        return false;
    };

    return { isFilterTypeValid };
};
